import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import InternalStatisticsCategoryEdit from './InternalStatisticsCategoryEdit';
import { SocketContext } from '../../../App';
import { useContext, useEffect, useRef } from 'react';
import { Switch } from 'antd';

export default function InternalStatisticsCategory(props: any) {

    const ref = useRef<any>(undefined);

    /** api服务id */
    const apiId = 'internalStatisticsCategory';

    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // handleChangeOne = ref.current.handleChangeOne;
        }

        //同步获取数据 async - await
        const fetchData = async () => {
        }

        if (contextData?.currentAreaId) {
            if (contextData?.refresh) {
                onRefresh({ areaId: contextData?.currentAreaId })
            }
        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextData?.currentAreaId]); //初始化数据

    const onRefresh = (item: any) => {
        const { areaId } = item;
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                areaId
            }
        }
        ref.current.initData(currentData);

        setContextData({ ...contextData, refresh: false })
    }

    //表头
    const columnsHead = [
        {
            title: '地区',
            dataIndex: 'areaName',
            render: (text: any, record: any) => {
                if (record.area) {
                    return (
                        <div>{record.area.areaName}</div>
                    )
                }
            }
        },
        {
            title: '大分类名称',
            dataIndex: 'internalStatisticsCategoryName',
        },
        {
            title: '各地通用',
            dataIndex: 'isPublic',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
            sorter: true,
        },
    ];
    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '内部统计大分类',
        apiId: 'internalStatisticsCategory',
        showStates: true,
        columns,
        pagination: true,
        EditComponent: InternalStatisticsCategoryEdit,
        sendPageData: { areaId: contextData?.currentAreaId },
        mountDataOptions: {
            userMount: {
                isArea: true
            }
        }
    };

    return (
        <WebUniversalNewEx props={extendProps} ref={ref}></WebUniversalNewEx>
    )
}